var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.closeModal()
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeModal()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-container",
                class: { "container-modal": _vm.responsive },
                style: {
                  width: _vm.width + "px",
                  height: _vm.height ? _vm.height + "px" : "auto"
                }
              },
              [
                _c(
                  "div",
                  {
                    style: _vm.hasButtonX
                      ? Object.assign(
                          {},
                          _vm.defaultHeaderStyle,
                          _vm.headerStyle
                        )
                      : Object.assign(
                          {},
                          _vm.defaultHeaderStyleHasButtonX,
                          _vm.headerStyleHasButtonX
                        )
                  },
                  [
                    _c("p", { staticClass: "title", style: _vm.titleStyle }, [
                      _vm._v(_vm._s(_vm.titulo))
                    ]),
                    _vm.hasButtonX
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            style: _vm.getColor,
                            attrs: { id: "btn", type: "text", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.triggerCloseModal()
                              }
                            },
                            nativeOn: {
                              mouseover: function($event) {
                                return _vm.hover($event)
                              },
                              mouseout: function($event) {
                                return _vm.leave($event)
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons icon",
                                style: _vm.titleStyle
                              },
                              [_vm._v("close")]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "app-vue-perfect-scrollbar",
                  {
                    style: Object.assign(
                      {},
                      _vm.defaultBodyStyle,
                      _vm.bodyStyle
                    ),
                    attrs: { settings: _vm.settings }
                  },
                  [_vm._t("body")],
                  2
                ),
                _vm.hasFooter
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          style: Object.assign(
                            {},
                            _vm.defaultFooterStyle,
                            _vm.footerStyle
                          )
                        },
                        [_vm._t("footer")],
                        2
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f16773c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f16773c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModal.vue
// module id = null
// module chunks = 